module.exports = __webpack_public_path__ + "static/media/Саматов Б.Т., Juraey B.I..dcc0fda8.pdf";